import {
  ecommerceTrigger,
} from '@utils/analytics';
import { clerk } from '@utils/clerk';
import { generateGoToDetailEvent } from '@utils/clerk/events';

/*
 * When we open a catalog we generate event which task about new page but when
 * we use filters or sorting type we get content without reload so for cover
 * this case we need to call event by yourself using this function.
 *
 * ps: pagination is not a new page (if we'll use infinite scroll then it will
 * true :))
 */
export const generateNewPageEvent = <T>(fun: T): T => {
  clerk.sendPageView();

  return fun;
};

/*
 * Now all feeds are implemented with using html without react, so we need to
 * use current function to add listeners on click event for product items.
 */
export const initGoToDetailEvent = () => {
  document
    .querySelectorAll('.js-b-tile-item')
    .forEach((item) => {
      item.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLButtonElement;

        try {
          if (target.dataset.itemCount && target.dataset.id) {
            generateGoToDetailEvent(
              target.dataset.itemCount,
              target.dataset.id,
              target.dataset.clerkSource || '',
            );
          }
        } catch {
          // do nothing
        }

        try {
          ecommerceTrigger({
            event: 'select_item',
            products: [{
              id: +(target.dataset.id || -1),
              name: target.getAttribute('title') || '',
              price: +(target.dataset.productPrice || -1),
              catalog: target.dataset.productCatalogSlug
                ? { slug: target.dataset.productCatalogSlug }
                : undefined,
              brand: target.dataset.productBrandName
                ? { name: target.dataset.productBrandName }
                : undefined,
            }],
          });
        } catch (err) {
           
          console.error(err);
        }
      });
    });
};
